// @flow
import React, { type Node } from 'react';
import styled from 'styled-components';

import { mergeClassNames } from 'utils/functions';
import Button from 'bs/Button';
import Icon from 'components/Icon';

const StyledModal = styled.div`
    .btn.close {
        box-shadow: none;
    }
    .modal-body {
        overflow-x: hidden;
    }
`;

type ModalSize = 'xl' | 'lg' | 'sm' | '';

type ModalProps = {
    /** sets modal title */
    title: string,

    /** footer content */
    footer: Node,

    /** modal size: 'lg' or 'sm' */
    size: ModalSize,

    /** toggles if modal uses 'container-fluid' if you're going to use a grid inside */
    usesContainer: boolean,

    /** will be appended to the classes */
    className?: string,

    /** callback to dismiss Modal */
    dismissModal(): void,

    /** children are rendered in modal body */
    children: Node,

    /** optional callback for letting components know the modal has mounted **/
    modalDidMount(): void,
};

export class Modal extends React.Component<ModalProps> {
    static defaultProps = {
        title: '',
        footer: null,
        usesContainer: false,
        modalDidMount: () => {},
    };

    componentDidMount(){
        // TODO fix the HealthClaims so it doesn't need this callback
        if(this.props.modalDidMount) {
            this.props.modalDidMount();
        }
    }

    render() {
        let {
            title,
            footer,
            size,
            className,
            dismissModal,
            dismissIcon,
            children,
            usesContainer,
            modalDidMount, // eslint-disable-line
            ...domProps
        } = this.props;

        className = mergeClassNames(
            'modal-dialog modal-dialog-scrollable',
            `${size ? 'modal-' + size : ''}`,
            className
        );

        if (usesContainer) {
            children = <div className='container-fluid'>{children}</div>;
        }

        return (
            <StyledModal>
                <div className='modal show fade d-block' tabIndex='-1' role='dialog'>
                    <div className={className} {...domProps} role='document'>
                        <div className='modal-content'>
                            {title && (
                                <div className='modal-header'>
                                    <h5 className='modal-title'>{title}</h5>
                                    <Button
                                        flavor=''
                                        className='close'
                                        onClick={dismissModal}
                                    >
                                        {dismissIcon || <Icon name='times' />}
                                    </Button>
                                </div>
                            )}

                            <div className='modal-body'>{children}</div>

                            {footer && <div className='modal-footer'>{footer}</div>}
                        </div>
                    </div>
                </div>
                <div className='modal-backdrop fade show' />
            </StyledModal>
        );
    }
}

export default Modal;
